import Vue from '../vue';
import router from '../router';
import VueMatomo from 'vue-matomo';
import { trackMatomoPageView } from '../libraries/matomo';

const siteId = window['matomoSiteId'];
if (siteId) {
  Vue.use(VueMatomo, {
    host: 'https://eversanahsi.matomo.cloud',
    siteId,
    trackInitialView: false,
  });

  router.afterEach((to, from) => {
    if (!to.meta.analyticsIgnore) {
      setTimeout(() => trackMatomoPageView(to, from), 1000);
    }
  });
}